import React from "react";

import "../desc-extrato/Style.css"
import MenuLateral from "../../menu-lateral/MenuLateral";
import Header from "../../header/Header";
import Extrato from "../Extrato";
import moment from 'moment';
import 'moment/locale/pt-br';

import { BiShoppingBag } from "react-icons/bi"

export default function (props) {
    return (
        <div className="desc-extrato">
            {props.data ? 
                
                <div>
                    <h2>Detalhes</h2>
                    <div>
                        <p>Data: {moment(props.data.entryDate).locale('pt-br').format("DD [de] MMMM [de] YYYY, HH:mm")}</p>
                        <p>Descrição: {props.data.details}</p>
                        <p>Valor: R${props.data.entryValue}</p>
                    </div>
                </div>
                : ""
            }
           {/*  <div>
                <h1>20 de Janeiro 2022 , 8:40</h1>
                <h2>Cartao Fisico com final 4552</h2>
            </div>

            <div>
                <div className="icone">
                    < BiShoppingBag />
                </div>

                <div>
                    <h2>Magazine Luisa</h2>
                </div>
            </div>

            <div className="valores">
                <h2>Valor</h2>
                <h3>R$ 1.700,00</h3>
            </div> */}
        </div>
    )
}